//- SCRIPTS DO ESPECIAL

$(function () {
    var $general = $('#general-especial');

    // $($('body').hasClass('mobile')) {
    //     $('.open-intro', $general).text('Ler matéria');
    // }

    if ($('.custom-video').length) {
        var player = new Plyr('.custom-video', {
            controls: ['play', 'progress', 'fullscreen', 'current-time'],
            fullscreen: { enabled: true, fallback: true, iosNative: true }
        });
    }

    var changeBlock = function(target) {
        var iframe = $('.youtube-player', $general),
            src = iframe.data('src');

        $('#general-especial').removeClass('hash');

        if (target == '#modal-video') {
            player.play();

            $(target).addClass('active')
        }
        else if (target == '#historias-intro') {
            player.stop();
            iframe.attr('src', src);

            $('#general-especial', $general).addClass('intro-open');

            $('section.init', $general).removeClass('active');
            $('section.historias', $general).addClass('active');

            $('#modal-video', $general).removeClass('active');
            $('#historias-intro', $general).addClass('active');
            $('#historias-intro').scrollTop(0);
        }
        else if (target == '#historias-lista') {
            $('#historias-intro', $general).removeClass('active');

            $('#general-especial', $general).removeClass('intro-open');
            $('#historias-intro', $general).removeClass('active');

            iframe.attr('src', '');
        } else {
            $('section.init', $general)
                .addClass('active')
                .siblings()
                .removeClass('active');


            window.location.hash = '';
        }
    }

    // FUNCTIONS
    var verifyHash = function() {
        var target = window.location.hash;

        if (target == '#historias-lista') {
            $('section.historias, ' + target, $general)
                .addClass('active')
                .siblings()
                .removeClass('active');
        }
    }

    var carousel = function() {
        $('.carousel').each(function() {
            var $carousel = $(this),
                $wrapper = $('.wrapper', $carousel);

            $($wrapper).owlCarousel({
                items: 1,
                lazyLoad: true,
                loop: true,
                nav: true,
                navContainer: $wrapper,
                dots: false,
                margin: 6
            })
        })
    }

    var mainHeight = function() {
        if ($('body').hasClass('mobile')) {
            var height;

            if ($(window).outerWidth() <= 720) {
                if ($('#header').css('display') == 'none') {
                    height = window.innerHeight;
                } else {
                    height = window.innerHeight - 48;
                }
            } else {
                height = window.innerHeight - 64;
            }

            $('#general-especial.home main').height(height);
            $('#general-especial.home main .historias-intro').css('min-height', height);
        }
    }

    var playVideo = function(e) {
        $('video', this).get(0).play();
    }

    var pauseVideo = function(e) {
        $('video', this).get(0).pause();
    }

    var videoVolume = function() {
        var $list = $('#historias-lista'),
            $video = $list.find('li video');

        if ($list.hasClass('muted')) {
            $list.removeClass('muted');
            $video.prop('muted', false);
        } else {
            $list.addClass('muted');
            $video.prop('muted', true);
        }
    }

    // EVENTS
    $(window).resize(function() {
        mainHeight();
    });

    $(window).on('hashchange', function() {
        verifyHash(window.location.hash);
    })

    $('li .volume', $general).on('click', function(){
        videoVolume();
    })

    $('#historias-lista li', $general).hover(function(){
        if ($('body').hasClass('mobile')) {
        } else {
            var $video = $('video', $(this)).get(0),
                promise = $video.play();

            if (promise !== null){
                promise.catch(function(){ $video.play(); })
            }
        }
    }, function(){
        $('video', $(this)).get(0).pause();
    });

    $('.open-block', $general).on('click', function() {
        $('body').removeClass('open-especial');

        var target = $(this).data('target');

        changeBlock(target);
    });

    if ($('#general-especial').hasClass('home')) {
        verifyHash(window.location.hash);
        mainHeight();
    }

    carousel();
});






